import {get, includes, trim, find, uniq} from 'lodash'

export default {
  computed: {
    activeTab () {
      return this.$store.getters.activeTab
    },
    gmailUser () {
      const activeUser = this.$store.getters.userInfo || this.$store.getters.activeUser
      return get(activeUser, 'email', 'k.syndikat@gmail.com')
    }
  },
  methods: {
    getInfoMail (thread, index, tags) {
      const hasIndex = index || index === 0
      const indexFirst = hasIndex ? index : 0
      const lastIndex = hasIndex ? index : thread.messages.length - 1
      const firstMsg = get(thread.messages, indexFirst, {})
      const currentIndex = this.activeTab === 'INBOX' ? lastIndex : indexFirst
      const msg = get(thread.messages, currentIndex, {})
      const headers = get(msg, 'payload.headers', [])
      const labels = this.getLabels(thread)
      return {
        dateId: new Date(),
        date: this.getDate(headers),
        snippet: this.getSnippet(thread, firstMsg),
        from: this.getFrom(thread.messages, hasIndex, currentIndex),
        to: this.getFrom(thread.messages, hasIndex, currentIndex),
        cc: this.getCc(headers, 'Cc'),
        bcc: this.getCc(headers, 'Bcc'),
        subject: this.getSubject(headers),
        unread: this.getUnreadStatus(msg),
        labelIds: labels,
        isDraft: labels[0] === 'DRAFT'
      }
    },
    getCc (headers, type) {
      const email = find(headers, {name: type})
      return email ? email.value : ''
    },
    getUnreadStatus (msg) {
      const labels = get(msg, 'labelIds', [])
      return includes(labels, 'UNREAD')
    },
    getSubject (headers) {
      const subject = find(headers, {name: 'Subject'})
      if (!subject) return ''
      return subject.value
    },
    getAllAddresses (messages, field) {
      return messages.map(item => {
        const header = get(item, 'payload.headers', [])
        const from = get(find(header, {name: field}), 'value', '')
        const email = trim(from.match(/<.+>/gi)).replace(/(^<)|(>$)/gi, '')
        const name = trim(from.match(/.+\s/gi)) || from
        return {
          name: name || '',
          email: email || from
        }
      })
    },
    getFrom (messages, hasIndex, index) {
      const allFrom = this.getAllAddresses(messages, 'From')
      const allTo = this.getAllAddresses(messages, 'To')
      const allAddresses = allFrom.concat(allTo)
      return hasIndex ? allFrom[index] : allAddresses.find(item => item.email !== this.gmailUser) || {}
    },
    getDate (headers) {
      const date = find(headers, {name: 'Date'})
      if (!date) return ''
      return date.value
    },
    getSnippet (thread, msg) {
      if (!thread) return ''
      const snippet = thread.snippet || ''
      if (!thread.messages) return snippet
      return get(msg, 'snippet', '')
    },
    getLabels (thread) {
      if (!thread) return []
      const messages = get(thread, 'messages', [])
      const labelsIds = messages.reduce((acc, msg) => {
        acc = acc.concat(msg.labelIds)
        return acc
      }, [])
      return uniq(labelsIds)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getInfoFromThread.js